export enum GenerateTripAccommodations {
  False = 0,
  True = 1,
  OnlyForValidRests = 2,
  OnlyPolish = 3, // @TODO check on API
}
